import type { IcIcon } from "./types";

export const IcError: IcIcon = (properties) => (
  <svg
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
    {...properties}
  >
    <g id="error">
      <path
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
        fill="currentColor"
        id="Vector"
      />
      <path
        d="M7.01302 10.777C6.8563 10.7828 6.70164 10.7399 6.57023 10.6544C6.43882 10.5688 6.3371 10.4447 6.27902 10.299C6.21979 10.1526 6.20644 9.99173 6.24073 9.83762C6.27502 9.6835 6.35533 9.54344 6.47102 9.43599C6.61668 9.29866 6.80932 9.22217 7.00952 9.22217C7.20971 9.22217 7.40235 9.29866 7.54802 9.43599C7.62098 9.50708 7.67897 9.59206 7.71857 9.68592C7.75816 9.77978 7.77856 9.88062 7.77856 9.98249C7.77856 10.0844 7.75816 10.1852 7.71857 10.2791C7.67897 10.3729 7.62098 10.4579 7.54802 10.529C7.48075 10.605 7.39851 10.6662 7.30644 10.7089C7.21437 10.7516 7.11447 10.7748 7.01302 10.777Z"
        fill={properties.fill ?? "white"}
        id="Vector_2"
      />
      <path
        d="M7.74999 3.396H6.24998V8.063H7.74999V3.396Z"
        fill={properties.fill ?? "white"}
        id="Vector_3"
      />
    </g>
  </svg>
);
